import {ADD_SYMBOL, HANDLE_COMMAND} from '../UserInput/actions';
import {
  TOGGLE_HISTORY,
  OPEN_SETTINGS,
  CLOSE_SETTINGS,
  TOGGLE_UNDO,
  SHOW_KEYBOARD,
  HIDE_KEYBOARD,
} from './actions';

export function ui(state: UIState, {type}: Action): UIState {
  switch (type) {
    case TOGGLE_HISTORY:
      return {
        ...state,
        historyVisible: !state.historyVisible,
      };

    case OPEN_SETTINGS:
      return {
        ...state,
        settingsVisible: true,
        keyboardVisible: false,
        historyVisible: false,
      };

    case CLOSE_SETTINGS:
      return {
        ...state,
        settingsVisible: false,
        keyboardVisible: true,
      };

    case SHOW_KEYBOARD:
      return {
        ...state,
        keyboardVisible: true,
      };

    case HIDE_KEYBOARD:
      return {
        ...state,
        keyboardVisible: false,
      };

    case TOGGLE_UNDO:
      return {
        ...state,
        undoButtonVisible: !state.undoButtonVisible,
      };

    case ADD_SYMBOL:
    case HANDLE_COMMAND:
      return {
        ...state,
        undoButtonVisible: false,
      };

    default:
      return state;
  }
}
